import { render, staticRenderFns } from "./ClinicWorkStep.vue?vue&type=template&id=4bebfe9c&"
import script from "./ClinicWorkStep.vue?vue&type=script&lang=js&"
export * from "./ClinicWorkStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports